import { render, staticRenderFns } from "./ParcellesActionsComponent.vue?vue&type=template&id=f445a084"
import script from "./ParcellesActionsComponent.vue?vue&type=script&lang=js"
export * from "./ParcellesActionsComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports